import type { StudentAppSetting, StudentId } from '@mathflat/domain/Student'
import { studentApi } from '@mathflat/domain/Student'

// QA 용 override 는 앱 몫이라 도메인 요청 함수를 감싸는 얇은 래퍼로 남긴다.
// 이름 변환은 도메인 adapter 가 끝낸 뒤라 여기서는 한글 이름으로 다룬다.
export const studentAppSettingLoader = {
  getStudentAppSettings: async (studentId: StudentId): Promise<StudentAppSetting> => {
    const data = await studentApi.getStudentAppSetting(studentId)
    // [DEV ONLY] QA 도구: studentAppSetting 4 플래그를 임시로 override 한다.
    //   - production 빌드에선 import.meta.env.DEV=false 라 통째로 tree-shaken (dead code)
    //   - localStorage 에 저장하면 page reload 후에도 유지, globalThis 는 페이지 reload 시 휘발
    //
    // 사용 예 (브라우저 dev console):
    //   localStorage.setItem('__APP_SETTING_OVERRIDE__', JSON.stringify({
    //     일반채점_채점전정답공개: false,
    //     채점후정답해설공개:     false,
    //     채점전문풀동공개:       false,
    //     채점후문풀동공개:       false,
    //   }))
    //   // 학습지/교재 진입 시 override 적용된 setting 으로 ViewOption 생성됨.
    //   // 끝나면 정리:
    //   localStorage.removeItem('__APP_SETTING_OVERRIDE__')
    //
    // 자세한 가이드: apps/mathflat-student/.claude/tc/05-testing-guide.md
    if (import.meta.env.DEV) {
      let override = (globalThis as { __APP_SETTING_OVERRIDE__?: Partial<StudentAppSetting> })
        .__APP_SETTING_OVERRIDE__
      if (!override) {
        try {
          const stored = localStorage.getItem('__APP_SETTING_OVERRIDE__')
          if (stored) override = JSON.parse(stored) as Partial<StudentAppSetting>
        } catch {
          /* ignore parse errors */
        }
      }
      if (override) {
        return { ...data, ...override }
      }
    }
    return data
  },
}
